export type Shop = 'manual' | 'cogo'

export function isShop(value: unknown): value is Shop {
  return value === 'manual' || value === 'cogo'
}

/** Order.shop when set; otherwise tenant default. */
export function resolveShop(
  orderShop: Shop | null | undefined,
  defaultShop: Shop | null | undefined
): Shop {
  if (isShop(orderShop)) return orderShop
  if (isShop(defaultShop)) return defaultShop
  return 'manual'
}
